import { TrackAddon } from '../TrackPlayer/TrackAddon';
import type { AudioDocProps } from '../TrackPlayer/types';

/**
 * AudioDoc — Knowledge Hub add-on that plays a text-to-speech reading of the
 * document/chapter script.
 *
 * Hidden from end users today: AudioDoc is excluded from admin's create/edit
 * flow (MED-7032), so no project can actually enable it. It's still wired
 * like any other add-on (its own tab, status and toast) rather than
 * special-cased — see addOnTabs.tsx.
 *
 * Same shape as `<Podcast>` — both wrap a single `<TrackPlayer>` via
 * `<TrackAddon>`, which is where the two variants actually differ
 * (gradient + paused icon).
 */
export const AudioDoc = (props: AudioDocProps) => (
  <TrackAddon trackKey="audioDoc" {...props} />
);

export default AudioDoc;
